var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from './CaseActions.module.scss';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { ButtonOptions } from 'src/ui/components/button/ButtonOptions';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { useState } from 'react';
import { Modal } from 'src/ui/components/modal/Modal';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { COLORS } from 'src/shared/styles/colors';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_TOOLTIP_POSITION, Tooltip } from 'src/ui/components/ToolTip/Tooltip';
/**
 *
 * @param props
 * @constructor
 *
 * From old MO, BPMN should specify max number of button shown on screen
 * Check if hidden is not true to display it
 * emphasize, states not use
 * menu action at true, set button in options (as isExtra)
 * confirmationModal, specify if intermediate modal should be open
 */
export var CaseActions = function (props) {
    var _a, _b, _c;
    var i18n = props.i18n, actions = props.actions, documentNbStatusRecap = props.documentNbStatusRecap, onActionsConfirm = props.onActionsConfirm;
    var _d = useState(null), actionModal = _d[0], setActionModal = _d[1];
    if (!actions || actions.length < 1) {
        return null;
    }
    var getWordingByStatus = function () {
        var _a, _b, _c, _d;
        if (documentNbStatusRecap.unknownStatus > 0) {
            if (documentNbStatusRecap.koStatus > 0) {
                return (_b = (_a = getPropsByKeyPath(i18n.modules, 'confirmActionModal.alertDocUnknownAndKo')) === null || _a === void 0 ? void 0 : _a.replace('$numberKo', documentNbStatusRecap.koStatus)) === null || _b === void 0 ? void 0 : _b.replace('$numberUnknown', documentNbStatusRecap.unknownStatus);
            }
            return (_c = getPropsByKeyPath(i18n.modules, 'confirmActionModal.alertDocUnknown')) === null || _c === void 0 ? void 0 : _c.replace('$numberUnknown', documentNbStatusRecap.unknownStatus);
        }
        if (documentNbStatusRecap.koStatus > 0) {
            return (_d = getPropsByKeyPath(i18n.modules, 'confirmActionModal.alertDocKo')) === null || _d === void 0 ? void 0 : _d.replace('$numberKo', documentNbStatusRecap.koStatus);
        }
    };
    var cancelButtonLabel = getPropsByKeyPath(i18n.modules, 'confirmActionModal.cancelButtonLabel');
    var moreActionTooltip = getPropsByKeyPath(i18n.components, 'tooltips.caseDetails.actions.more');
    var buttonToDisplay = actions.filter(function (btn) { return !btn.isExtra; });
    var buttonToExtra = actions.filter(function (btn) { return btn.isExtra; }); // hide in more icon
    var handleButtonClick = function (btn) {
        var confirmationModal = btn.confirmationModal;
        if (confirmationModal) {
            setActionModal(btn);
        }
        else {
            onActionsConfirm(btn);
        }
    };
    var handleModalIsConfirm = function () {
        onActionsConfirm(actionModal);
        setActionModal(null);
    };
    var isValidActionModal = (actionModal === null || actionModal === void 0 ? void 0 : actionModal.type) === EButtonType.VALID;
    var isAbortActionModal = (actionModal === null || actionModal === void 0 ? void 0 : actionModal.type) === EButtonType.ABORT;
    var colorActionModal = isValidActionModal ? COLORS.GREEN['500'] : isAbortActionModal ? COLORS.RED['500'] : undefined;
    return (_jsxs(_Fragment, { children: [actionModal && (_jsxs(Modal, __assign({ onClose: function () { return setActionModal(null); }, title: (_a = actionModal.confirmationModal) === null || _a === void 0 ? void 0 : _a.title, className: styles.caseActionConfirmationModal, color: colorActionModal }, { children: [((_b = actionModal === null || actionModal === void 0 ? void 0 : actionModal.confirmationModal) === null || _b === void 0 ? void 0 : _b.showDocDecisionAlert) && (_jsxs("div", __assign({ className: styles.warningMissingDocDecisionWrapper }, { children: [_jsx(Icons, { icon: E_ICONS.WARNING, color: COLORS.ORANGE['500'], className: styles.warningLogo }), _jsx("p", __assign({ className: styles.descriptionText }, { children: getWordingByStatus() }))] }))), _jsxs("div", __assign({ className: styles.caseActionButtonWrapper }, { children: [_jsx(Button, { label: cancelButtonLabel, isEdge: true, type: actionModal === null || actionModal === void 0 ? void 0 : actionModal.type, onClick: function () { return setActionModal(null); } }), _jsx(Button, { label: (_c = actionModal.confirmationModal) === null || _c === void 0 ? void 0 : _c.confirmButtonLabel, type: actionModal === null || actionModal === void 0 ? void 0 : actionModal.type, onClick: handleModalIsConfirm })] }))] }))), _jsxs("div", __assign({ className: styles.caseActionsWrapper }, { children: [_jsx("div", __assign({ className: styles.caseActionsButtonDisplayed }, { children: buttonToDisplay.map(function (btn) { return (_jsx(Button, __assign({ type: btn.type }, btn, { onClick: function () { return handleButtonClick(btn); } }), btn.label)); }) })), buttonToExtra.length > 0 && (_jsxs("span", { children: [_jsx(Tooltip, __assign({ position: E_TOOLTIP_POSITION.LEFT }, { children: moreActionTooltip })), _jsx(ButtonOptions, { icon: E_ICONS.MORE, options: buttonToExtra, onOptionsClick: handleButtonClick })] }))] }))] }));
};
